<template>
  <div class="container">
    <div class="about-content">
      <h1 class="about-title">关盈堂古中医简介</h1>

      <!-- 导语 -->
      <p class="about-lead">
        传承古中医智慧，创新现代中医。关盈堂古中医是一个以五运六气为核心理论搭建的平台。融合现代科技，结合智能系统的创新型中医体系。致力于将晦涩难懂的古中医智慧变成简单易学能落地的中医项目，让更多喜欢古中医的文化传播者进行学习，服务走进寻常百姓家。
      </p>

      <!-- 一、核心理念 -->
      <section class="about-section">
        <h2 class="section-title">
          <span class="section-idx">一</span>
          <span class="section-name">核心理念</span>
        </h2>
        <p class="section-text">
          关盈堂古中医。坚信五运六气是天地间的真理。秉持开放共享的精神让更多的喜欢中医文化的人来学习，传播。服务大众健康。
        </p>
      </section>

      <!-- 二、核心理论 -->
      <section class="about-section">
        <h2 class="section-title">
          <span class="section-idx">二</span>
          <span class="section-name">核心理论</span>
        </h2>
        <p class="section-text">
          关盈堂五运六气，通过精准推算患者出生时的先天体质，和后天节气的交感。找到疾病真正的病根。对疑难顽疾更有方向。
        </p>
      </section>

      <!-- 三、数字赋能 -->
      <section class="about-section">
        <h2 class="section-title">
          <span class="section-idx">三</span>
          <span class="section-name">数字赋能</span>
        </h2>
        <p class="section-text">
          智能化诊疗辅助系统。关盈堂自主研发的智能化诊疗系统。将复杂的五运六气推算，简单化、数字化、标准化。让学习者能快速掌握，实现精准辨证，一人一方。
        </p>
      </section>

      <!-- 四、使命和展望 -->
      <section class="about-section">
        <h2 class="section-title">
          <span class="section-idx">四</span>
          <span class="section-name">使命和展望</span>
        </h2>
        <p class="section-text">
          关盈堂古中医。不仅传播五运六气，更是启迪古中医智慧。为中医的复兴推广做出自己的贡献。普惠古中医文化让更多的百姓人人知医，人人自医，天下无疾。
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style scoped>
.container {
  width: 100%;
  max-width: 880px;
  min-height: 520px;
  height: auto;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 8px 20px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.about-content {
  width: 100%;
  text-align: left;
  margin: 20px 0;
}

/* 标题 */
.about-title {
  margin: 0 0 24px;
  font-size: 30px;
  font-weight: 700;
  color: #304744;
  letter-spacing: 1px;
  text-align: center;
}

/* 导语 */
.about-lead {
  margin: 0 0 36px;
  font-size: 18px;
  line-height: 34px;
  color: #304744;
  text-indent: 2em;
}

/* 分节 */
.about-section {
  margin-bottom: 28px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 12px;
  font-size: 20px;
  font-weight: 700;
  color: #009798;
}

.section-idx {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #e6f4f1;
  color: #009798;
  font-size: 16px;
  font-weight: 700;
}

.section-text {
  margin: 0;
  font-size: 18px;
  line-height: 34px;
  color: #527f77;
  text-indent: 2em;
}

@media (max-width: 768px) {
  .container {
    padding: 8px 16px 32px;
  }

  .about-title {
    font-size: 24px;
  }

  .about-lead,
  .section-text {
    font-size: 16px;
    line-height: 30px;
  }
}
</style>
